const QuickSelection = {
    update: function (html) {
        jQuery('#quickSelectionWrap').replaceWith(html);
    }
};

export default QuickSelection;
